import { OrganisationApiService } from '@common/ApiService'

const ORGANISATIONS_SUCCESS = 'ORGANISATIONS_SUCCESS'
const ORGANISATION_SUCCESS = 'ORGANISATION_SUCCESS'
const ORGANISATION_ERROR = 'ORGANISATION_ERROR'
const ALL_ORGANISATION_SUCCESS = 'ALL_ORGANISATION_SUCCESS'
const TOC_ORGANISATIONS_SUCCESS = 'TOC_ORGANISATIONS_SUCCESS'

export const state = {
  all: [],
  toc: [],
  organisation: {},
  errors: {},
}

export const TOC = {
  name: 'TOC',
}

export const getters = {}

export const mutations = {
  [TOC_ORGANISATIONS_SUCCESS](state, data) {
    state.toc = data
    return state
  },

  [ORGANISATION_SUCCESS](state, data) {
    state.organisation = data
    return state
  },

  [ORGANISATIONS_SUCCESS](state, data) {
    state.all = data
    state.all.unshift(TOC)
    return state
  },

  [ALL_ORGANISATION_SUCCESS](state, data) {
    state.all = data
    return state
  },

  [ORGANISATION_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },
}

export const actions = {
  createOrganisation({ commit }, newOrganisation) {
    return new Promise((resolve) => {
      return OrganisationApiService.post({
        ...newOrganisation,
      }).then((response) => {
        commit(ORGANISATION_SUCCESS, response.data)
        resolve(response.data)
      })
    })
  },

  updateOrganisation({ commit }, { id, params }) {
    return new Promise((resolve) => {
      return OrganisationApiService.patch(id, params)
        .then((response) => {
          commit(ORGANISATION_SUCCESS, response.data)
          resolve(response.data)
        })
        .catch((error) => commit(ORGANISATION_ERROR, error))
    })
  },

  fetchOrganisationById({ commit }, id) {
    return new Promise((resolve) => {
      return OrganisationApiService.get(id)
        .then((response) => {
          commit(ORGANISATION_SUCCESS, response.data)
          resolve(response.data)
        })
        .catch((error) => commit(ORGANISATION_ERROR, error))
    })
  },

  fetchOrganisationsByCategory({ commit }, category) {
    return new Promise((resolve) => {
      return OrganisationApiService.query({
        category: category,
      })
        .then((response) => {
          commit(ALL_ORGANISATION_SUCCESS, response.data)
          resolve(response.data)
        })
        .catch((error) => commit(ORGANISATION_ERROR, error))
    })
  },

  fetchTocOrganisations({ commit }) {
    return new Promise((resolve) => {
      return OrganisationApiService.query({
        category: 'toc',
      })
        .then((response) => {
          commit(TOC_ORGANISATIONS_SUCCESS, response.data)
          resolve(response.data)
        })
        .catch((error) => commit(ORGANISATION_ERROR, error))
    })
  },

  fetchOrganisations({ commit }) {
    return new Promise((resolve) => {
      return OrganisationApiService.query({
        toc: false,
      })
        .then((response) => {
          commit(ORGANISATIONS_SUCCESS, response.data)
          resolve(response.data)
        })
        .catch((error) => commit(ORGANISATION_ERROR, error))
    })
  },

  fetchAllOrganisations({ commit }, query) {
    query = query || {}
    return new Promise((resolve) => {
      return OrganisationApiService.query(query)
        .then((response) => {
          commit(ALL_ORGANISATION_SUCCESS, response.data)
          resolve(response.data)
        })
        .catch((error) => commit(ORGANISATION_ERROR, error))
    })
  },
}
